import { connect } from "react-redux";
import { Link } from "react-router-dom";

var ReactTooltip = require("react-tooltip");

var TextTypes = require("lib/academic/TextTypes")
var Features = require("lib/account/Features");

var ReadingLevelDisplay = require("components/reading/reading_levels/ReadingLevelDisplay")
var ReadingLevelFormat = require("lib/academic/ReadingLevelFormat");

var StudentDisplay = require("components/users/students/StudentDisplay");
var StudentListDisplay = require("components/org/student_lists/StudentListDisplay");
var StudentAvatar = require("components/avatars/StudentAvatar");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var UIActions = require("lib/actions/UIActions");
var PaywallModal = require("components/users/teachers/PaywallModal");

require("reading/reading_levels/reading_level_table.scss");

@connect(
	(state, props) => ({
		students: RosterSelectors.students({ state, conditions: { ids: props.userIDs }}),
		clozeEnabled: Features.isEnabled(Features.CLOZE_ASSESSMENTS)
	}),
	(dispatch, props) => ({
		showRLDPaywall: () =>
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.CLOZE_ASSESSMENTS })),
	})
)
class ReadingLevelTable extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { expanded: false };
	}

	getReadingLevel(userID, date) {
		var matches = _.where(this.props.readingLevels, {
			student_id: userID, assessment_date: date
		})
		return _.sortBy(matches, "created_at").reverse()[0];
	}

	render() {
		var dates = this.props.dates.slice().reverse();

		var rows = _.map(this.props.students, (student) => {
			var userID = student.id;

			var studentInfoCell = (
				<td>
					<div className="avatarBox hideOnPrint">
						<StudentAvatar studentID={ userID } maxWidth={ 30 } />
					</div>
					<div className="names">
						<StudentDisplay studentID={ userID } />
						<StudentListDisplay studentID={ userID } />
					</div>
				</td>
			); 

			var assessmentCells = dates.map((date) => {
				var rl = this.getReadingLevel(userID, date);
				var status = student.cloze_status;

				if (status && status.trigger && status.date === date) {
					var progress = Math.round(100 * status.current / status.target);
					var rlDisplay = (
						<span>
							{ progress }% Complete
						</span>
					);
				} else if (rl) {
					var rlDisplay = (<ReadingLevelDisplay lexile={ rl.reading_level } />);
				} else {
					var rlDisplay = "-";
				}

				return (
					<td key={ date }>
						{ rlDisplay }
					</td>
				);
			})

			return (
				<tr key={ userID }>
					{ studentInfoCell }
					<td>
						<ReadingLevelDisplay lexile={ student.current_reading_level } />
						<div className="rlOrigin">
							{ ReadingLevelFormat.getOriginName(student.current_reading_level_origin) }
						</div>
					</td>
				</tr>
			)
		});

		return (
			<div className="readingLevelTable">
				<table className="table table-bordered">
					<tbody>
						<tr>
							<th className="studentColumn">
								Student
							</th>
							<th>
								Most Recent
							</th>
						</tr>
						{ rows }
					</tbody>
				</table>
			</div>
		);
	}
}

ReadingLevelTable.WrappedComponent.propTypes = StrictPropTypes({
	userIDs: PropTypes.array.isRequired,
	readingLevels: PropTypes.array.isRequired,
	dates: PropTypes.array.isRequired,
	hasRLDs: PropTypes.bool,

	// Data from @connect
	students: PropTypes.array,
	clozeEnabled: PropTypes.bool,

	// Handlers from @connect
	showRLDPaywall: PropTypes.func
});

module.exports = ReadingLevelTable


// WEBPACK FOOTER //
// ./modules/components/reading/reading_levels/ReadingLevelTable.js